import classnames from 'clsx';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import PlayButton from '../../shared/PlayButton';
import GuideItemTitle from '../../shared/GuideItemTitle';
import ImageWithDefault from '../../../shared/ImageWithDefault';
import Titles from '../../shared/Titles';
import hasNoBehavior from '../../../../utils/guideItem/hasNoBehavior';
import css from '../../shared/guide-item.module.scss';
import commonCss from '../../../../styles/common.module.scss';

const Default = ({
  guideItem,
  selectedContentId,
  index,
  isClickHandlerEnabled,
  containerClassName,
  imageWrapperClassName,
  getStyles,
}) => {
  const { style, properties, guideId, title, subtitle, image } = guideItem;
  const {
    tileSize,
    tileShape,
    titleSize,
    tileTitleAlignment,
    titleMaxLineCount,
    subtitleSize,
    subtitleMaxLineCount,
  } = getStyles(style);
  const nextTitle = get(properties, 'seoInfo.title', '');
  const guideItemImageWrapperClassNames = classnames(
    css.guideItemImageWrapper,
    css[`guideItemImageWrapper${tileSize}`],
    imageWrapperClassName,
  );

  return (
    <div
      className={classnames('row', css.guideItemContainer, containerClassName)}
      data-testid={`guideItem-${index}`}
      data-testtype="defaultTile"
      data-nexttitle={nextTitle}
      data-nextguideitem={guideId}
    >
      <div
        data-testid="defaultTileOverlay"
        className={
          isClickHandlerEnabled || hasNoBehavior(guideItem)
            ? ''
            : commonCss.overlay
        }
      >
        {image && (
          <div
            data-testid="guideItemImageWrapper"
            className={guideItemImageWrapperClassNames}
          >
            <PlayButton
              guideItem={guideItem}
              className={css.guideItemPlayButtonContainer}
              iconFontSize="30px"
              tileSize={tileSize}
              tileShape={tileShape}
              isClickHandlerEnabled={isClickHandlerEnabled}
            >
              <ImageWithDefault
                dataTestId="guideItemImage"
                className={css.guideItemImageFill}
                src={image}
                alt={title}
              />
            </PlayButton>
          </div>
        )}
        <GuideItemTitle
          guideItem={guideItem}
          selectedContentId={selectedContentId}
          hasImage={!!image}
          isClickHandlerEnabled={isClickHandlerEnabled}
        >
          <Titles
            title={title}
            subtitle={subtitle}
            titleSize={titleSize}
            titleMaxLineCount={titleMaxLineCount}
            titleAlignment={tileTitleAlignment}
            subtitleSize={subtitleSize}
            subtitleMaxLineCount={parseInt(subtitleMaxLineCount, 10) || 1}
          />
        </GuideItemTitle>
      </div>
    </div>
  );
};

Default.propTypes = {
  guideItem: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  selectedContentId: PropTypes.string,
  isClickHandlerEnabled: PropTypes.bool,
  containerClassName: PropTypes.string,
  imageWrapperClassName: PropTypes.string,
  getStyles: PropTypes.func,
};

Default.defaultProps = {
  guideItem: {},
  getStyles: () => ({}),
  isClickHandlerEnabled: false,
};

export default Default;
